<ion-header class="remove-margin-from-safe-area ion-no-border">
  <ion-toolbar >
    <ion-grid>
      <ion-row>
        <ion-col>
          <ion-toolbar>
          <ion-buttons slot="end">
            <ion-button (click)="cancel()" 
              ><ion-icon color="dark" name="close"></ion-icon
            ></ion-button>
          </ion-buttons>
        </ion-toolbar>
        </ion-col>
      </ion-row>
      <ion-row>
        <ion-col style="text-align: center;">
          <h3 style="color: #000;
          font-size: 28px;
          font-style: normal;
          font-weight: 400;
          line-height: 120%; /* 33.6px */">{{type}}</h3>
        </ion-col>
      </ion-row>
    </ion-grid>
    
   
  </ion-toolbar>
</ion-header>
<ion-content>
  <ion-grid>
    <ion-row style="background: red">
      <ion-grid>
        <ion-row>
          <ion-col style="text-align: center">
            <ion-title style="color: white;font-weight: bold;"> {{ ('keys.data.payments.current' |
              translate : {Default:'Current'}) || 'Current' }}</ion-title>
          </ion-col>
        </ion-row>
        <ion-row>
          <ion-col size-xs="12"
          offset-xs="0"
          size-sm="12"
          offset-sm="0"
          size-md="12"
          offset-md="0"
          size-lg="8"
          offset-lg="2"
          size-xl="6"
          offset-xl="3">
            <ion-card
              style="
                border-radius: 1em;
                aspect-ratio: 1.586;
                 background: linear-gradient(112deg, #1D2F46 1.29%, #D2D2D2 114.81%);
              "
            >
              
                <ion-grid style="height: 100%;">
                  <ion-row style="height: 70%;">
                  <ion-col size="12" style="text-align: center">
                    <ion-title style="color: white; position: absolute;
                    bottom: 0px;
                    left: 0px;">{{
                      oldMethod['displayNumber']
                    }}</ion-title></ion-col
                  >
                </ion-row>
                <ion-row style="height: 30%;">
                  <ion-col>
                    <img
              *ngIf="oldMethod['amex']"
              style="
                width: 30%;
                position: absolute;
                bottom: 0px;
                right: 0px;
              "
              src="assets/payments/amex.png"
            />
              <img
                *ngIf="oldMethod['mastercard']"
                style="width: 40%; position: absolute; bottom: 0px; right: 0px"
                src="assets/payments/mastercard.png"
              />
              <img
                *ngIf="oldMethod['visa']"
                style="
                  width: 40%;
                  position: absolute;
                  bottom: 0px;
                  right: 0px;
                  padding: 1em;
                "
                src="assets/payments/visa.png"
              />
                    </ion-col>
                    </ion-row>
                </ion-grid>
              
              
            </ion-card>
          </ion-col>
        </ion-row>
      </ion-grid>
    </ion-row>
    <ion-row style="background: green">
      <ion-grid>
        <ion-row>
          <ion-col style="text-align: center">
            <ion-title style="color: white;font-weight: bold;">New</ion-title>
          </ion-col>
        </ion-row>
        <ion-row>
          <ion-col size-xs="12"
        offset-xs="0"
        size-sm="12"
        offset-sm="0"
        size-md="12"
        offset-md="0"
        size-lg="8"
        offset-lg="2"
        size-xl="6"
        offset-xl="3">
            <ion-card
              style="
                border-radius: 1em;
                aspect-ratio: 1.586;
                 background: linear-gradient(112deg, #1D2F46 1.29%, #D2D2D2 114.81%);
              "
            >
              
                <ion-grid style="height: 100%;">
                  <ion-row style="height: 70%;">
                    <ion-col size="12" style="text-align: center">
                      <ion-title style="color: white; position: absolute;
                      bottom: 0px;
                      left: 0px;">{{
                        newMethod['displayNumber']
                      }}</ion-title></ion-col
                    >
                  </ion-row>
                  <ion-row style="height: 30%;">
                    <ion-col>
                      <img
              *ngIf="newMethod['amex']"
              style="
                width: 30%;
                position: absolute;
                bottom: 0px;
                right: 0px;
              "
              src="assets/payments/amex.png"
            />
              <img
                *ngIf="newMethod['mastercard']"
                style="width: 40%; position: absolute; bottom: 0px; right: 0px"
                src="assets/payments/mastercard.png"
              />
              <img
                *ngIf="newMethod['visa']"
                style="
                  width: 40%;
                  position: absolute;
                  bottom: 0px;
                  right: 0px;
                  padding: 1em;
                "
                src="assets/payments/visa.png"
              />
                      </ion-col>
                      </ion-row>
                </ion-grid>
              
              
            </ion-card>
          </ion-col>
        </ion-row>
      </ion-grid>
    </ion-row>
    
  </ion-grid>
</ion-content>
<ion-footer>
<ion-grid>
  <ion-row>
    <ion-col>
      <ion-button (click)="replace()" expand="block" color="primary">
        {{ ('keys.data.payments.replace_with_new' |
                        translate : {Default:'Replace with New'}) || 'Replace with New' }}
      </ion-button>
    </ion-col>
  </ion-row>
  <ion-row>
    <ion-col>
      <ion-button (click)="cancel()" expand="block" color="danger" fill="outline">
        {{ ('keys.data.common.cancel' |
                        translate  : {Default:'Cancel'}) || 'Cancel' }}
      </ion-button>
    </ion-col>
    
  </ion-row>
</ion-grid>
</ion-footer>
